import React from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Carousel from '../../../components/Carousel'
import moment from "moment";

const VisualiserDemandeModal = ({id, userConnectedId, handleValidateStatus, data}) => {

  const renderInfo = () => {
    return (
      <div className='overflow-auto' style={{maxHeight: '325px'}}>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Marque</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vehicule?.modele?.marque?.nom ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Modèle</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vehicule?.modele?.nom ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Immatriculation</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.immatriculation ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Numéro d’identification</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.numero ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Mise en circulation</div>
          <div className='mb-5 fs-4 bold me-2'>
            {(data?.datePremiereImmat) ? moment(data?.datePremiereImmat).format('DD/MM/YYYY') : ''}
          </div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>N° série</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vin}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Genre</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vehicule?.modele?.type?.code ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Puissance</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vehicule?.modele?.puissance ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Boîte de vitesse</div>
          <div className='mb-5 fs-4 bold me-2'>{}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Type variante version</div>
          <div className='mb-5 fs-4 bold me-2'>{}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Date CG</div>
          <div className='mb-5 fs-4 bold me-2'>{}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Contrôle SIV</div>
          <div className='mb-5 fs-4 bold me-2'>{}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>CNIT</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vehicule?.cnit ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>VIN</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.vin ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Date d’entrée en stock</div>
          <div className='mb-5 fs-4 bold me-2'>
            {(data?.date_entree_stock) ? moment(data?.date_entree_stock).format('DD/MM/YYYY') : ''}
          </div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Site</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.site?.code ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Zone</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.zone ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Allée</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.allee ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Kilométrage</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.km?.toLocaleString('fr-FR')+ ' Km' ?? 'NC'} </div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Code moteur</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.codeMoteur ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Carburant</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.energie ?? ''}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Transmission</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.boiteAuto ? 1 : 0}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Nombres de portes</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.nombrePortes}</div>
        </div>
        <div className='d-flex justify-content-between'>
          <div className='mb-5 bold text-gray-600 fs-4'>Couleur</div>
          <div className='mb-5 fs-4 bold me-2'>{data?.couleur}</div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="modal fade" id="visualiserDemandeModal" tabIndex={-1} aria-labelledby="visualiserDemandeModalLabel"
           aria-hidden="true">
        <div className='modal-dialog modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                Détails du véhicule n° {data?.numero} {data?.vehicule?.modele?.marque?.nom} {data?.vehicule?.modele?.nom}
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-md-6'>
                  <Carousel
                    loading={true}
                    imagesArray={[]}
                    nomPiece={''}
                    taille={'600x400'}
                  />
                </div>
                <div className='card d-flex flex-column w-50'>
                  <div className='card-header fs-2 d-flex align-items-center'>
                    Information sur le véhicule
                  </div>
                  <div className='card-body'>
                    <div>{renderInfo()}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={() =>
                  handleValidateStatus(id, 'valider', userConnectedId)
                }
              >
                Valider
              </button>
              <button
                type='button'
                className='btn btn-danger'
                data-bs-dismiss='modal'
                onClick={() =>
                  handleValidateStatus(id, 'refuser', userConnectedId)
                }
              >
                Refuser
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {VisualiserDemandeModal}
